import createReactContext from '@ant-design/create-react-context';
var FormContext = createReactContext({
  labelAlign: 'right',
  vertical: false
});
export default FormContext;